<div class="card-filters" fxLayout.lt-md="column" fxLayoutGap="8px" fxLayout="row" fxLayoutAlign.lt-md="center start">
    <ng-content></ng-content>
</div>
